//Redux action Types

export const SET = "one-state-patient-verified/set";
export const REINIT = "one-state-patient-verified/reset";